import axios from "axios";
import i18n from "@/lib/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // Token-based auth via Authorization Bearer header (stored in localStorage).
  // Disabling credentials mode avoids CORS conflicts with platform ingress
  // (Cloudflare/Emergent host returns `access-control-allow-origin: *` on
  // non-preflight responses, which browsers reject when credentials mode is
  // `include`).
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token =
    typeof window !== "undefined" ? localStorage.getItem("qrise_token") : null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || i18n.t("errors.generic");
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail?.code && i18n.exists(`errors.${detail.code}`)) return i18n.t(`errors.${detail.code}`, detail);
  if (typeof detail?.message === "string") return detail.message;
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
